import { render, staticRenderFns } from "./Resourcepage.vue?vue&type=template&id=335e75ef&scoped=true"
import script from "./Resourcepage.vue?vue&type=script&lang=js"
export * from "./Resourcepage.vue?vue&type=script&lang=js"
import style0 from "./Resourcepage.vue?vue&type=style&index=0&id=335e75ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e75ef",
  null
  
)

export default component.exports